if (!customElements.get('lookbook-card')) {
  customElements.define(
    'lookbook-card',
    class LookbookCard extends ModalComponent {
      constructor() {
        super();

        this.card = this.closest('.lbcard');
      }

      connectedCallback() {
        super.connectedCallback();

        // Hover only on devices that support true hover (no touch)
        if (window.matchMedia('(hover: hover)').matches) {
          this._onCardEnter = () => this.show(null, true);
          this._onCardLeave = () => this.hide();

          this.card.addEventListener('mouseenter', this._onCardEnter);
          this.card.addEventListener('mouseleave', this._onCardLeave);
        }
      }

      disconnectedCallback() {
        super.disconnectedCallback();

        if (this._onCardEnter) {
          this.card.removeEventListener('mouseenter', this._onCardEnter);
          this.card.removeEventListener('mouseleave', this._onCardLeave);
        }
      }

      prepareToShow() {
        super.prepareToShow();

        this.card.classList.add('is-open');
      }

      handleAfterHide() {
        super.handleAfterHide();

        this.card.classList.remove('is-open');
      }
    }
  );
}
